@use "../../../../shared/scss" as *;

:host {
  @include pds-text-small;
  display: flex;
}
